export default __webpack_public_path__ + "static/media/img-b-result-distance-fr_fr@3x.e2ed8bda.jpg";